import builder from '@rsql/builder';
import { emit } from '@rsql/emitter';
import InputTypes from '../../../enums/InputTypes';
import { isEmpty } from '../../../utils/ValidForm';

export const prepareFilter = (inputs, data, options) => {
    const campos = [];
    const { transformToSearch = true, transformToNameUse = true } = options ?? {};
    const transformValue = (input, valor, completeData) => {
        const useLike = (input?.filter ?? {}).hasOwnProperty('useLike')
            ? input?.filter.useLike
            : !(
                  input?.type === InputTypes.INTEGER ||
                  input?.type === InputTypes.DOUBLE ||
                  input?.type === InputTypes.FLOAT ||
                  input?.type === InputTypes.ENTITY
              );
        if (transformToNameUse && typeof valor === 'object' && completeData) {
            valor = eval(
                `completeData?.${input?.filter?.nameUse
                    .replaceAll('?.', '.')
                    .replaceAll('.', '?.')}`
            );
        }
        return useLike ? `*${valor}*` : `${valor}`;
    };

    for (let i = 0; i < inputs.length; i++) {
        const { name, type, filter } = inputs[i];
        if (data[name] !== null && `${data[name]}`.trim().length > 0) {
            let value = transformValue({ name, type, filter }, data[name], data);
            if (type === InputTypes.BOOLEAN) {
                value = data[name] ? true : false;
                value = `${value}`;
            }

            campos.push(builder.eq(`${filter?.nameUse ?? name}`, value));
        }
    }
    if (transformToSearch) {
        return { search: emit(builder.and(...campos)) };
    }
    return campos;
};

export default class BaseConfigFilter {
    campos = [];
    #inputs = [];
    #inputByType;
    constructor(inputs) {
        this.campos = [];
        if (Array.isArray(inputs)) {
            this.#inputs = inputs;
            this.#inputByType = inputs.reduce(function (prev, curr) {
                const useLike = !(
                    curr?.type === InputTypes.INTEGER ||
                    curr?.type === InputTypes.DOUBLE ||
                    curr?.type === InputTypes.FLOAT ||
                    curr?.type === InputTypes.ENTITY
                );

                prev[curr?.name] = {
                    type: curr?.type,
                    nameUse: curr?.filter?.nameUse ?? curr?.name,
                    useLike: curr?.filter?.useLike ?? useLike,
                };
                return prev;
            }, {});
            this.prepareInitialValues();
        }
    }

    static setInput(cmpName, value) {
        return { name: cmpName, nameUse: cmpName, original: value, value: value };
    }

    setInitialValues(values) {
        this.initialValues = values;
    }

    prepareInitialValues() {
        this.initialValues = this.#inputs.reduce(function (prev, curr) {
            prev[curr?.name] =
                curr?.filter?.initialValue === undefined ? '' : curr?.filter?.initialValue;
            return prev;
        }, {});
    }

    addCampo(data, name) {
        if (
            data?.[name] !== null &&
            data?.[name] !== undefined &&
            `${data[name]}`.trim().length > 0
        ) {
            var val = this.#inputByType[name]?.useLike ? `*${data[name]}*` : `${data[name]}`;
            if (this.#inputByType[name]?.type === InputTypes.BOOLEAN) {
                val = data[name] ? true : false;
                val = `${val}`;
            }

            this.campos.push({
                nameUse: this.#inputByType[name]?.nameUse,
                name: name,
                value: val,
                original: data[name],
            });
        }
    }

    addAll(data) {
        this.campos = [];
        let keys = Object.keys(this.initialValues);

        for (let i = 0; i < keys.length; i++) {
            this.addCampo(data, keys[i]);
        }
    }

    setInitialFilter(inputs) {
        const inputsWithParams = this.#inputs.filter(
            (input) => input?.filter?.use && !isEmpty(input?.filter?.paramName)
        );
        const retorno = [];
        for (let i = 0; i < inputsWithParams.length; i++) {
            const input = inputsWithParams[i];
            const name = input?.filter?.nameUse ?? input?.name;
            if (!isEmpty(inputs?.pageParams?.[input?.filter?.paramName])) {
                retorno.push(
                    BaseConfigFilter.setInput(name, inputs?.pageParams?.[input?.filter?.paramName])
                );
            }
        }
        return retorno;
    }

    beforeSubmit(data) {
        this.addAll(data);

        let res = this.setInitialFilter(data);
        this.campos = [...this.campos, ...res];

        return this.campos;
    }

    onSubmit(data, onFiltro, customFilter, prefix = '') {
        let filters = {};

        let query = [];

        let retorno = this.beforeSubmit(data);

        if (retorno.length > 0) {
            for (let i = 0; i < retorno.length; i++) {
                let res = builder.eq(`${prefix}${retorno[i].nameUse}`, retorno[i].value);

                if (customFilter?.[retorno[i].name]) {
                    res = customFilter?.[retorno[i].name](
                        { ...retorno[i], nameUse: `${prefix}${retorno[i].nameUse}` },
                        data
                    );
                }

                if (Array.isArray(res)) {
                    query = [...query, ...res];
                } else if (res !== null && res !== undefined) {
                    query.push(res);
                }
            }
        }
        let search = '';
        if (query.length > 0) {
            search = emit(builder.and(...query));
            filters = { search };
        }

        if (onFiltro) {
            onFiltro(filters);
        }

        return search;
    }
}
